<div class="content" style="width: 100%; height: 80%;">
  <mat-form-field appearance="fill" style="width: 80vw;">
    <mat-label>Collection</mat-label>
    <mat-select [value]="selectedCollection" (selectionChange)="onCollectionChange($event)">
      <mat-option *ngFor="let collection of collections" [value]="collection.title">
        {{collection.title}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  &nbsp;&nbsp;
  <button (click)="aiSettings()" mat-raised-button color="primary">Settings</button>&nbsp;

  <button [matMenuTriggerFor]="menu44" mat-raised-button color="primary">Start</button>&nbsp;
  <mat-menu class="primary" #menu44="matMenu">
    <b style="padding-left:15px;">Selected</b>
    <button mat-menu-item (click)="runSelection(0)">Step 1</button>
    <button mat-menu-item (click)="runSelection(1)">Step 2</button>
    <button mat-menu-item (click)="runSelection(2)">Step 3</button>
    <button mat-menu-item (click)="runSelection(3)">Step 4</button>
    <mat-divider></mat-divider>
    <br>
    <b style="padding-left:15px;">️Filtered</b>
    <button mat-menu-item (click)="runFiltered(0)">Step 1</button>
    <button mat-menu-item (click)="runFiltered(1)">Step 2</button>
    <button mat-menu-item (click)="runFiltered(2)">Step 3</button>
    <button mat-menu-item (click)="runFiltered(3)">Step 4</button>
  </mat-menu>

  <mat-chip-list aria-label="Fish selection" style="display: inline-block; margin-left: 15px;">
    <mat-chip *ngFor="let chip of chips; let i = index" (click)="onChipClick(chip, i)" [class.active-ai-tags-chip]="chip === activeChipElement">{{chip}}</mat-chip>
  </mat-chip-list>
  <br>
  <br>

  <!-- The AG Grid component, with Dimensions, CSS Theme, Row Data, and Column Definition -->
  <ag-grid-angular
    class="ag-theme-alpine"
    [pagination]="true"
    [serverSideInfiniteScroll]="true"
    [paginationPageSize]="500"
    [cacheBlockSize]="500"
    [maxBlocksInCache]="10"
    [maxConcurrentDatasourceRequests]="1"
    [getContextMenuItems]="getGptContextMenuItems"
    [enableRangeSelection]="false"
    [rowModelType]="'serverSide'"
    [columnDefs]="columnDefs"
    [suppressCopyRowsToClipboard]="true"
    [defaultColDef]="defaultColDef"
    [animateRows]="true"
    [rowSelection]="'multiple'"
    (selectionChanged)="onSelectionChanged($event)"
    [suppressRowClickSelection]="false"
    [stopEditingWhenCellsLoseFocus]="false"
    (gridReady)="onGridReady($event)"
  ></ag-grid-angular>
</div>
